 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"acf0aa1590027b5f18b1ebc012245a006b3a7be3","2":"206ca005762bfe51068b3453b78d338e87585e89","3":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","4":"a1d79ebab46b21e8a8a5b055efbfe1e374535380","5":"7695358b5badde6b8a5b7b4830241c92e70c32f0","6":"f40a7dd94fb748f108a9b10e69bde394e45d1118","7":"framework","10":"component---gatsby-theme-husky-src-templates-404-404-tsx","11":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","12":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","13":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","14":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","15":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","16":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","17":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","18":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","19":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx","20":"component---gatsby-theme-husky-src-templates-where-to-buy-page-where-to-buy-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"0500a53837a2c8b5feff","1":"1820a22943cbfb2ed986","2":"5da8253bbe6505be1bbb","3":"4cdfeae1c65d3f3c798f","4":"bc49bf9da3a87b4c0803","5":"76663566902199f0eb53","6":"2deddec931e4d0c21aef","7":"e00645fcd4677a45b102","10":"b5e77362048b9e6591c3","11":"8ef8df0ff5ef5a2b7664","12":"0003b5a9441d5135c23e","13":"b81cec192eb30f985fc2","14":"04e57ccc22f90d57f095","15":"c07512afdeec1ff62fbe","16":"a5aa4fc9cbc7858ac453","17":"676df0585b0c4891a2fa","18":"0dfa89be024c3dbac7f8","19":"e01d32e737b7ffe35064","20":"3cef1d0cddee064a8cf7","23":"438e48d44a8b6d18ee59","24":"487abaf56619c06905b0","25":"6821b855952240c034c8","26":"0ac97c7c023a79cd0ee6","27":"99d6d6c3d8bf9ebbbd21","28":"d8c3899695cab1ff2d43"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"acf0aa1590027b5f18b1ebc012245a006b3a7be3","2":"206ca005762bfe51068b3453b78d338e87585e89","3":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","4":"a1d79ebab46b21e8a8a5b055efbfe1e374535380","5":"7695358b5badde6b8a5b7b4830241c92e70c32f0","6":"f40a7dd94fb748f108a9b10e69bde394e45d1118","7":"framework","10":"component---gatsby-theme-husky-src-templates-404-404-tsx","11":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","12":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","13":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","14":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","15":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","16":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","17":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","18":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","19":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx","20":"component---gatsby-theme-husky-src-templates-where-to-buy-page-where-to-buy-page-tsx"}[chunkId]||chunkId) + "." + {"0":"f051451f82cd17e9413a","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","10":"eb6de9d72030a786dd73","11":"d02fc7ac5181c5e6a871","12":"bf9a784fc1918c3fed3c","13":"251bf815f21769b56f62","14":"8339e0795ca606108422","15":"7f6ece8de5f24f1a15bd","16":"cb042ef2e7290194837a","17":"84110558335942bace2f","18":"eb98b0baa6afd15ec0ca","19":"b7560e8ce7a20d872ce2","20":"53178810ec7b5b752478","23":"71f642986343521409c3","24":"a9c5c01c1d383b3d0bd3","25":"7005f88c9b1f1b5c216d","26":"f43d9df51d04124d05d9","27":"57ccbd6b99d49d4c48e4","28":"b87f36b2210c5126b4f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
